export default "__VITE_ASSET__CtRam_4x__"